<template>
  <div
    :class="{
      'inline-block': ['union_position_package', 'exclude_union_position_package'].includes(formKey),
      'scene-spec-section': ['scene_spec'].includes(formKey) && !formItem.isPreview
    }"
  >
    <!-- 版位定投场景配置 -->
    <div v-if="formKey === 'scene_spec' && !formItem.isPreview" class="scene-spec-title">版位定投场景配置</div>
    <!-- 搜索场景扩量(搜索关键词) -->
    <div v-if="formKey === 'search_bidwords'">
      <div v-if="!formItem.isPreview" class="flex items-center">
        <el-button type="primary" size="mini" @click="custom_keywords_visible = true">添加关键词</el-button>
        <span class="ml-10">已添加{{ formItem.value.length }}个</span>
      </div>
      <div v-if="formItem.isPreview" class="flex">
        <span class="mr-10">关键词{{ formItem.value.length }}个</span>
        <div style="color: #409eff;" class="cursor-pointer" @click="() => onViewBidwords(formItem.value)">查看</div>
      </div>
      <!--广告版位/搜索场景扩量/关键词编辑-->
      <custom-keywords
        v-if="custom_keywords_visible"
        :visible.sync="custom_keywords_visible"
        :keywords="formItem.value"
        :advertiser-id="initOps.advertiser_ids[0]"
        @confirm="formItem.value= $event || []"
      />
      <!-- 关键词详情 -->
      <el-dialog :visible.sync="keywords_detail.visible" v-bind="keywords_detail.props">
        <el-tag v-for="keyword in keywords_detail.data" :key="keyword" class="mr-10"> {{ keyword }}</el-tag>
        <el-empty v-if="!keywords_detail.data.length" />
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { component_props } from '@/views/fusion/investment/intelligence-create/components/main-view/components/step-form/model/props';
import { data_sharing_mixin } from '@/views/fusion/investment/intelligence-create/mixins/data-sharing';
export default {
  components: {
    'custom-keywords': () => import('./components/custom-keywords/index.vue'),
  },
  mixins: [data_sharing_mixin],
  props: {
    ...component_props,
  },
  data() {
    return {
      /** 关键词编辑显示 */
      custom_keywords_visible: false,
      /** 关键词详情 */
      keywords_detail: {
        visible: false,
        data: [],
        props: {
          width: '800px',
          title: '关键词详情',
        },
      },
    };
  },
  methods: {
    /**
     * 查看关键词详情
     * @param {Array} keywords 关键词列表
     * @returns {void}
     */
    onViewBidwords(keywords) {
      Object.assign(this.keywords_detail, {
        data: keywords,
        visible: true,
      });
    },
  },
};
</script>

<style lang="scss">
.scene-spec-section {
  position: sticky;
  top:0;
  border-bottom: 1px solid rgb(230, 235, 245);
  padding: 10px;
  background-color: #F5F7FA;
  z-index: 10;
  .scene-spec-title {
    font-size: 16px;
    font-weight: 700;
  }
}
</style>
